import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSolarPanel: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="solar-panel, Photovoltaics, energy, electricity"><path d="M4.75 20.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M5.75 3.75H18.25L20.25 14.25H3.75L5.75 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 4V20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 9H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSolarPanel;
